// extracted by mini-css-extract-plugin
export default {"container":"Ar-z","brandName":"Br-z","productName":"Cr-z","productNamePdpEnhancements":"Dr-z","breakLongProductName":"Er-z"};